<template>
  <div>
    <h1>mmmmm something went wrong</h1>
  </div>
</template>

<script>



export default {
  name: 'ErrorView',
  mounted() {
  }
}
</script>



// WEBPACK FOOTER //
// ErrorView.vue?5ebb37bb